import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/language-switcher.css';

const languages = [
	{ code: 'it', label: 'Italiano', flag: '🇮🇹' },
	{ code: 'de', label: 'Deutsch', flag: '🇩🇪' },
	{ code: 'es', label: 'Español', flag: '🇪🇸' },
	{ code: 'zh', label: '中文', flag: '🇨🇳' },
	{ code: 'fr', label: 'Français', flag: '🇫🇷' },
];

const LanguageSwitcher = () => {
	const { i18n } = useTranslation();
	const [open, setOpen] = useState(false);
	const ref = useRef(null);

	const current = languages.find((l) => l.code === i18n.language) || languages[0];

	useEffect(() => {
		const handleClickOutside = (e) => {
			if (ref.current && !ref.current.contains(e.target)) {
				setOpen(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		document.addEventListener('touchstart', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
			document.removeEventListener('touchstart', handleClickOutside);
		};
	}, []);

	const changeLanguage = (code) => {
		i18n.changeLanguage(code);
		setOpen(false);
	};

	return (
		<div className="lang-switcher" ref={ref}>
			<button
				className="lang-switcher-btn"
				onClick={() => setOpen(!open)}
				aria-label="Change language"
				aria-expanded={open}
			>
				<span className="lang-flag">{current.flag}</span>
				<span className="lang-code">{current.code.toUpperCase()}</span>
				<svg className={`lang-chevron ${open ? 'lang-chevron-open' : ''}`} width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
					<polyline points="6 9 12 15 18 9" />
				</svg>
			</button>
			{open && (
				<div className="lang-dropdown">
					{languages.map((lang) => (
						<button
							key={lang.code}
							className={`lang-option ${lang.code === current.code ? 'lang-option-active' : ''}`}
							onClick={() => changeLanguage(lang.code)}
						>
							<span className="lang-flag">{lang.flag}</span>
							<span className="lang-option-label">{lang.label}</span>
						</button>
					))}
				</div>
			)}
		</div>
	);
};

export default LanguageSwitcher;
